import request from './service'
import store from './store/store'

export const separateThousand = (num) => {
  if (!num || num === '0') {
    return '0.00'
  } else {
    num = String(num)
    let decimal = num.split('.')[1]
    if (decimal && decimal.length === 1) {
      decimal += '0'
    } else if (decimal && decimal.length > 2) {
      decimal = decimal.substring(0, 2)
    }
    const integerInitial = num.split('.')[0]
    const reverseArr = integerInitial.split('').reverse()
    const integerReverseArr = []
    reverseArr.forEach((item, index) => {
      if (index && !(index % 3)) {
        integerReverseArr.push(',')
      }
      integerReverseArr.push(item)
    })
    const integer = integerReverseArr.reverse().join('')
    return integer + '.' + (decimal || '00')
  }
}

export const fetchBalance = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  request('post', '/innovation/account/getuserbalance', {
    userId: userInfo.UserId
  }, true).then(res => {
    // store.commit('setBalance', {
    //   Cash: 123456789,
    //   Bonus: 12345
    // })
    if (res.Inactive === true) {
      console.log('getuserbalance: log out')

      localStorage.removeItem('userInfo')
    } else {
      store.commit('setBalance', res)
    }
  })
}

/****
 * 检测是否手机浏览器访问
 * @returns {boolean}
 * 2021-09-28 C007 创建
 */
export const isMobileAgent = () => {
  let userAgentInfo = navigator.userAgent
  let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = false
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true
      break
    }
  }
  return flag
}

/****
 * User unique id from lcoal storage
 * @returns User unique id
 *
 * 2021-06-08 CHEN PU created function
 */
const getUserUniqueIdLocal = function () {
  var userInfoJSONStr = localStorage.getItem('userInfo')
  var userInfoJSON = null
  if (userInfoJSONStr) {
    userInfoJSON = JSON.parse(userInfoJSONStr)
  }
  return userInfoJSON == null ? null : userInfoJSON.UserId
}

/****
 * Get user visitor code
 * @returns user visitor code
 *
 * 2021-06-08 CHEN PU created function
 */
const getVisitorCode = () => {
  var visitorCode = localStorage.getItem('visitorCode')
  if (visitorCode == null) {
    visitorCode = generateUUID()
    localStorage.setItem('visitorCode', visitorCode)
  }
  return visitorCode
}

/****
 * Set user visitor code
 * @returns user visitor code
 *
 * 2021-06-08 CHEN PU created function
 */
const setVisitorCode = function (visitorCode) {
  if (visitorCode) {
    localStorage.setItem('visitorCode', visitorCode)
  }
}

/****
 * Create a unique id
 * @returns new unique id
 *
 * 2021-06-08 CHEN PU created function
 */
const generateUUID = () => {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

/****
 * 根据日期值返回日期英文名
 * @param month
 * @returns {string}
 * 2021-07-09 C007 创建
 */
export const getDayName = function (day) {
  let name = ''
  switch (day) {
    case 1:
      name = '1st'
      break
    case 2:
      name = '2nd'
      break
    case 3:
      name = '3rd'
      break
    case 4:
      name = '4th'
      break
    case 5:
      name = '5th'
      break
    case 6:
      name = '6th'
      break
    case 7:
      name = '7th'
      break
    case 8:
      name = '8th'
      break
    case 9:
      name = '9th'
      break
    case 10:
      name = '10th'
      break
    case 11:
      name = '11th'
      break
    case 12:
      name = '12th'
      break
    case 13:
      name = '13th'
      break
    case 14:
      name = '14th'
      break
    case 15:
      name = '15th'
      break
    case 16:
      name = '16th'
      break
    case 17:
      name = '17th'
      break
    case 18:
      name = '18th'
      break
    case 19:
      name = '19th'
      break
    case 20:
      name = '20th'
      break
    case 21:
      name = '1st'
      break
    case 22:
      name = '22nd'
      break
    case 23:
      name = '23rd'
      break
    case 24:
      name = '24th'
      break
    case 25:
      name = '25th'
      break
    case 26:
      name = '26th'
      break
    case 27:
      name = '27th'
      break
    case 28:
      name = '28th'
      break
    case 29:
      name = '29th'
      break
    case 30:
      name = '30th'
      break
    case 31:
      name = '31st'
      break
  }
  return name
}

/****
 * 根据月份值返回月份英文名
 * @param month
 * @returns {string}
 * 2021-07-09 C007 创建
 */
export const getMonthName = function (month) {
  let name = ''
  switch (month) {
    case 1:
      name = 'January'
      break
    case 2:
      name = 'February'
      break
    case 3:
      name = 'March'
      break
    case 4:
      name = 'April'
      break
    case 5:
      name = 'May'
      break
    case 6:
      name = 'June'
      break
    case 7:
      name = 'July'
      break
    case 8:
      name = 'August'
      break
    case 9:
      name = 'September'
      break
    case 10:
      name = 'October'
      break
    case 11:
      name = 'November'
      break
    case 12:
      name = 'December'
      break
  }
  return name
}
/**
 * 增加存储过期时间
 * 2023-05-24 WXJ Created
 */
export const Storage = {
  setExpire: (key, value, second) => {
    key = 'storage:key:' + key
    if (isNaN(second) || second < 1) {
      throw new Error('second is valid')
    }
    let time = second * 1000
    let obj = {
      data: value,
      time: Date.now(),
      second: time
    }
    localStorage.setItem(key, JSON.stringify(obj))
  },
  getExpire: key => {
    key = 'storage:key:' + key
    let val = localStorage.getItem(key)
    if (!val) {
      return val
    }
    val = JSON.parse(val)
    if (Date.now() > val.time + val.second) {
      localStorage.removeItem(key)
      return null
    }
    return val.data
  }
}
export const fbListener = (event) => {
  try {
    if (localStorage.getItem('cid') && store.state.fbCid.includes(localStorage.getItem('cid'))) { // 监听行为
      console.log(event)
      window.fbq('track', event, {
        value: 0.00,
        currency: 'INR'
      })
    }
  } catch (err) {
    console.log(err)
  }
}

const saveUserEventParams = function (event, userId, param1, param2, param3) {
  const url = '/innovation/account/save/user/event'
  const data = {
    EventNameEN: event,
    UserUniqueId: userId,
    Param1: param1 !== null ? param1 : 0,
    Param2: param2 !== null ? param2 : '',
    Param3: param3 !== null ? param3 : ''
  }
  request('post', url, data, true).then(res => {
  }).catch(err => {
    console.log(err)
  })
}

/****
 * Log utils
 *
 * 2021-06-08 CHEN PU Add for log visit
 */
export const LogUtils = {
  saveUserEventParams: saveUserEventParams,
  getUserUniqueIdLocal: getUserUniqueIdLocal,
  getVisitorCode: getVisitorCode,
  setVisitorCode: setVisitorCode,
  generateUUID: generateUUID,
  fbListener: fbListener
}

export const separateThousandInteger = (num) => {
  if (!num || num === '0') {
    return '0'
  } else {
    num = String(num)
    const integerInitial = num
    const reverseArr = integerInitial.split('').reverse()
    const integerReverseArr = []
    reverseArr.forEach((item, index) => {
      if (index && !(index % 3)) {
        integerReverseArr.push(',')
      }
      integerReverseArr.push(item)
    })
    const integer = integerReverseArr.reverse().join('')
    return integer
  }
}



// WEBPACK FOOTER //
// ./src/utils.js